/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-26 22:00:17
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-15 22:15:43
 * @FilePath: /unifyxp-v2-store-portal/src/tools/queryConvert.ts
 */
export const queryConvert = (q) => {
  const { search, filter, sort = {}, tableSettings = '' } = q || {};

  let _searchText = {};
  if (search && search.length > 0)
    _searchText = { searchText: (search || []).map((i) => i.value) };

  const filterData = _filter(filter || {});

  let _sortBy = {};
  if (sort.data) {
    _sortBy = { sortBy: sort.data };
  }
  const res = {
    ..._searchText,
    ...filterData,
    ..._sortBy,
    ...{ tableSettings: tableSettings },
  };

  return res;
};
const _filter = (filter) => {
  const re: any = {};
  if (filter.ratingRange) {
    if (filter.ratingRange.length > 1) {
      re.ratingRange = filter.ratingRange.map((i) => i.value);
    }
  } else if (filter.tag) {
    if (filter.tag.length > 0) {
      re.tag = {
        uuid: (filter.tag[0] || {}).value,
        name: (filter.tag[0] || {}).label,
      };
    }
  } else if (filter.salesChannel) {
    if (filter.salesChannel.length > 1) {
      re.salesChannel = {
        uuid: filter.salesChannel[1].value,
      };
    }
  } else if (filter.productTypes) {
    if (filter.productTypes.length > 0) {
      re.productTypes = filter.productTypes.map((i) => i.value);
    }
  } else {
    //  if (filter.tag.length > 0) {
    //    re.tag = {
    //      uuid: (filter.tag[0] || {}).value,
    //      name: (filter.tag[0] || {}).label,
    //    };
    //  }
  }
  return re;
};

export const queryConvert1 = (q, convertQuery) => {
  const { search, filter, sort = {} } = q || {};

  let _searchText = {};
  if (search && search.length > 0)
    _searchText = { searchText: (search || []).map((i) => i.value) };

  const filterData = convertQuery(filter);

  let _sortBy = {};
  if (sort.data) {
    _sortBy = { sortBy: sort.data };
  }
  const res = {
    ..._searchText,
    ...filterData,
    ..._sortBy,
    //...{ tableSettings: tableSettings },
  };

  return res;
};
